"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.questions.empty': '此步骤尚未配置问题。',
    'onboarding.questions.placeholder.text': '输入您的答案',
    'onboarding.questions.placeholder.textarea': '输入您的答案',
    'onboarding.questions.placeholder.number': '输入数字',
    'onboarding.questions.placeholder.select': '-- 选择选项 --',
    'onboarding.questions.required': '*',
};
